const mutations = {
  SET_TOKEN(state, token) {
    state.auth_data = token
  },
  TOKEN_FAILURE(state) {
    state.auth_data = null
  },
  SET_STORE_DATA(state, data) {
    state.store_data = data
  },
  SET_CUSTOMER_DATA(state, data) {
    state.customer_data = data
  },
  SET_URL_DOMAIN(state, data) {
    state.url_domain = data
    localStorage.setItem('olselforder_url_domain', data)
  },
  REMOVE_ERROR(state) {
    state.error_type = ''
    state.error_message = ''
    state.show_error = false
  },
  SET_ORDER(state, orderData) {
    state.order_data = orderData
  },
  SET_DATA_VERIFICATION(state, dataVerification) {
    state.data_verification = dataVerification
  },
  SET_TYPE_VERIFICATION(state, dataTypeVerification) {
    state.type_verification = dataTypeVerification
  },
  SET_ROUTER_DATA(state, routerData) {
    state.router_data = routerData
  },
  REMOVE_ITEM_ROUTER_DATA(state, routerData) {
    state.router_data = state.router_data.filter(item => item.name !== routerData.name)
  },
  REMOVE_ALL_ROUTER_DATA(state) {
    state.router_data = []
  },
  SET_QUERY_ROUTER(state, queryRouter) {
    if (queryRouter.length > 0) {
      queryRouter.forEach(item => {
        const index = state.query_router.findIndex(i => i.key === item.key)
        if (index !== -1) {
          state.query_router[index].value = item.value
        } else {
          state.query_router.push(item)
        }
      })
    } else {
      state.query_router = queryRouter
    }
  },
  

  ADD_ITEM_RESERVATION(state, reservationData) {
      const index = state.data_cart_reservation.findIndex(
        (i) => i.id === reservationData[0].id
      )
      if (index !== -1) {
        const currentData = reservationData[0]
        const newdata = state.data_cart_reservation.map(item => {
          if (item.id === currentData.id) {
            return currentData
          } else {
            return item
          }
        })

        state.data_cart_reservation = newdata
      } else {
        state.data_cart_reservation = [...state.data_cart_reservation, ...reservationData]
      }
  },

  ADD_MANY_ITEM_RESERVATION(state, reservationData) {
    state.data_cart_reservation = reservationData
  },

  REMOVE_ITEM_RESERVATION(state, item) {
    const index = state.data_cart_reservation.findIndex(
      (i) => i.id === item.id
    );
    if (index !== -1) {
      state.data_cart_reservation.splice(index, 1);
    }
  },

  REMOVE_ALL_RESERVATION(state) {
    state.data_cart_reservation = []
  },
  SET_PAYMENT(state, data) {
    state.payment = data
  },
  SET_OTP_FORGET_PASSWORD(state, data) {
    state.otp_forget_password = data
  },
}
export default mutations
